/***
 *
 *   PROFILE
 *   Update the user profile or close the account
 *
 **********/

import axios from "axios";
import { AccountNav, Animate, ViewContext } from "components/lib";
import { UnlimitedCard } from "components/unlimitedCard/card";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import blackloader from "./images/black_loader.gif";
import loader from "./images/loading.gif";
import styles from "./styles.module.scss";

export function Signature(props) {
  const sigPad = useRef({});

  // context
  const viewContext = useContext(ViewContext);
  const [loading, setLoading] = useState(true);
  const [button_loading, setButton_loading] = useState(false);
  const [signature, setSignature] = useState();

  function dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/png" });
  }

  async function runAPI() {
    axios
      .get("/api/user")
      .then((r) => {
        setLoading(false);
        setSignature(r.data.data.signature);
      })
      .catch((fileErr) => {
        setLoading(false);

        viewContext.notification.show(
          "Failed on get user signature.",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  useEffect(() => {
    runAPI();
  }, []);

  return (
    <Fragment>
      <AccountNav />
      <Animate>
        <div style={{ maxWidth: 505 }}>
          <UnlimitedCard>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={blackloader} alt="loader" style={{ width: 25 }} />
              </div>
            ) : (
              <>
                <div className={styles.title}>Current signature:</div>
                <div
                  style={{
                    backgroundImage: "url(" + signature + ")",
                    backgroundPosition: "center",
                    width: 455,
                    height: 200,
                    marginTop: 20,
                    marginBottom: 20,
                    border: "1px solid #383838",
                    borderRadius: 10,
                  }}
                />
                <div className={styles.title}>
                  Register your new e-signature
                </div>
                <span>Draw your signature below</span>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                  <ReactSignatureCanvas
                    ref={(ref) => {
                      sigPad.current = ref;
                    }}
                    canvasProps={{
                      width: 455,
                      height: 200,

                      className: styles.canvas,
                    }}
                  />
                  <div
                    className={styles.canvas_clear_button}
                    onClick={() => sigPad.current.clear()}
                  >
                    Clear
                  </div>
                </div>
                <div className={styles.footer}>
                  <div className={styles.buttons}>
                    <button
                      className={styles.save}
                      onClick={async () => {
                        if (!loading) {
                          setButton_loading(true);

                          const form_data = new FormData();
                          form_data.append(
                            "file",
                            dataURItoBlob(
                              sigPad.current
                                .getTrimmedCanvas()
                                .toDataURL("image/png")
                            )
                          );

                          await axios
                            .post(`/api/user/signature`, form_data, {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            })
                            .then(async (r) => {
                              await runAPI();

                              setButton_loading(false);

                              sigPad.current.clear();

                              viewContext.notification.show(
                                "Signature updated successfully!",
                                "success",
                                true,
                                "toast",
                                "check-circle"
                              );
                            })
                            .catch((fileErr) => {
                              setButton_loading(false);

                              viewContext.notification.show(
                                "Failed on upload file to server.",
                                "error",
                                true,
                                "toast",
                                "x-circle"
                              );
                            });
                        }
                      }}
                      style={
                        loading ? { cursor: "default" } : { cursor: "pointer" }
                      }
                    >
                      {button_loading ? (
                        <img src={loader} alt="loader" style={{ width: 25 }} />
                      ) : (
                        "Finish"
                      )}
                    </button>
                  </div>
                </div>
              </>
            )}
          </UnlimitedCard>
        </div>
      </Animate>
    </Fragment>
  );
}
